module.exports = __webpack_public_path__ + "img/icon-funding.7289901c.svg";